export const STORAGE_LANG_KEY = 'preferred_lang';

export const STORAGE_THEME_KEY = 'theme';

export const STORAGE_LIGHT_THEME_VALUE = 'light';

export const STORAGE_DARK_THEME_VALUE = 'dark';
